var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 949.6 1080",
    style: {
      enableBackground: "new 0 0 949.6 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;}\n\t.st3{fill:#E53366;}\n\t.st4{fill:#00D681;}\n\t.st5{fill:#4D6ADD;}\n\t.st6{fill:none;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#FCFCFC;}\n\t.st9{display:inline;fill:#FCFCFC;}\n\t.st10{display:inline;fill:#4D6ADD;}\n\t.st11{display:inline;fill:#E53366;}\n\t.st12{display:inline;fill:#00D681;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420.9,378.9h-17.1v65.5c6.1,0.2,12,1.5,17.3,3.7L420.9,378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.2,444.4v-65.3h-16c-1.3,7.7-2.2,15.8-2.2,23.9v43.4c4.6-1.3,9.4-2,14.2-2H357.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.9,
    y: 378.9,
    className: "st4",
    width: 17.3,
    height: 65.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M549.1,378.9h-17.3v69c5.5-2,11.2-3.3,17.3-3.5V378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M613.5,446.2v-43.4c0-8.1-0.7-16.2-2.2-23.9h-15.8v65.3h3.5C604.3,444.4,609.1,445.1,613.5,446.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.7,
    y: 378.9,
    className: "st4",
    width: 17.3,
    height: 65.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M632.1,475.9c-4.6-6.6-11.2-11.6-18.6-14.5c-4.4-1.8-9.2-2.6-14.2-2.6h-48c-22.3,0-40.5,18.2-40.5,40.5 c0,3.1,0.4,5.9,1.1,8.8l101.6-27.4L632.1,475.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M638.4,489.5l-25,6.8l-95.7,25.8c7.2,10.7,19.7,18,33.7,18h48c5,0,9.9-0.9,14.2-2.6 c15.3-5.7,26.3-20.6,26.3-37.9C639.8,496.1,639.3,492.8,638.4,489.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M476.3,613.7c9.2,0,16.9-7.4,16.9-16.9V450.1c0-9.2-7.4-16.9-16.9-16.9c-9.2,0-16.9,7.4-16.9,16.9v146.8 C459.5,606.3,467.1,613.7,476.3,613.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M525.2,598.8v-22.6c0-10.7-7.2-19.9-17.3-22.6v43.2c0,2.6-0.2,5.3-0.9,7.7h12.5 C522.6,604.5,525.2,601.9,525.2,598.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M437.1,541.4c2.4-1.1,5-1.8,7.4-2.4v-5.5C442.6,536.4,440,539,437.1,541.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M431.4,604.5h14.2c-0.7-2.4-0.9-5-0.9-7.7v-42.5c-10.1,3.5-17.3,12.9-17.3,24.1v22.3 C427.5,602.8,429.2,604.5,431.4,604.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M507.9,450.1v15.6c2.6-3.5,5.7-6.6,9.2-9.2v-77.3h-17.3v50.2C504.8,434.5,507.9,442,507.9,450.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444.8,465.7v-15.6c0-8.3,3.1-15.8,8.3-21.2v-49.7h-17.5l0.4,77.8C439.3,459.3,442.2,462.4,444.8,465.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M476.3,418.6c3.1,0,5.9,0.4,8.8,1.3v-40.7h-17.3v40.7C470.6,419,473.3,418.6,476.3,418.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M507.9,533.6v5.3c2.2,0.4,4.2,0.9,6.1,1.5C511.8,538.2,509.6,536,507.9,533.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M509,269.6v28.7c0,17.7-14.5,32.2-32.2,32.2c-17.7,0-32.2-14.5-32.2-32.2v-28.9c-48,11.4-86.1,48-99.9,94.8 H608C594.4,317.6,556.5,281.2,509,269.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577.5,646.8c-7.2,0.9-77.3,10.1-102.3,10.1c-24.3,0-93.1-9.2-100.3-10.1c-16.9,0.2-30.9,11.4-35.9,26.5 v4.4h274.5v-4.4C608.6,658.2,594.4,647,577.5,646.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.6,723.3h201.7c16.9,0,31.3-11,36.4-26.3c0-1.3,0-2.6,0-4.2v-0.4H339.2v0.4c0,1.3,0,2.6,0,4.2 C344.3,712.3,358.7,723.3,375.6,723.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M375.6,632.1h0.4h0.4c0.7,0,74.9,10.1,99,10.1c24.8,0,100.1-9.9,100.8-10.1h0.4h0.4 c14,0,26.9,5.5,36.4,14.5v-93.8c-4.6,1.3-9.4,2-14.2,2h-48c-7.7,0-15.1-1.5-21.7-4.4c6.4,6.8,10.3,16,10.3,25.8v22.6 c0,11.2-9.2,20.4-20.4,20.4h-21c-5.7,5.7-13.6,9.2-22.3,9.2s-16.6-3.5-22.3-9.2H431c-10.3,0-18.6-8.3-18.6-18.6v-22.1 c0-11.4,4.8-21.7,12.5-29.1c-7.2,3.5-15.3,5.5-24.1,5.5h-47.3c-4.8,0-9.6-0.7-14.2-2v93.8C348.6,637.6,361.6,632.1,375.6,632.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M577.1,737.9H375.4c-12,0-23.2-3.9-32-11c15.1,59.1,69,103,133,103l0,0c64,0,117.6-43.8,133-103 C600.3,734,589.2,737.9,577.1,737.9z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M476.8,239.2c-9.6,0-17.5,7.9-17.5,17.5v10.1v21.5v10.3c0,9.6,7.9,17.5,17.5,17.5c9.6,0,17.5-7.9,17.5-17.5 v-10.1V267v-10.3C494.3,247,486.4,239.2,476.8,239.2z M484.2,289.1v13.8c0,4.2-3.3,7.4-7.4,7.4c-4.2,0-7.4-3.3-7.4-7.4v-13.8 v-23.2v-13.8c0-4.2,3.3-7.4,7.4-7.4c4.2,0,7.4,3.3,7.4,7.4v13.8V289.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.9,499.6c0,17.3,11,32.2,26.3,37.9l0,0c0.4,0.2,0.9,0.4,1.3,0.4c0.2,0,0.2,0,0.4,0.2 c0.4,0.2,0.9,0.2,1.3,0.4c0.2,0,0.4,0,0.4,0.2c0.4,0,0.9,0.2,1.1,0.2s0.4,0,0.7,0.2c0.4,0,0.7,0.2,1.1,0.2c0.2,0,0.4,0,0.9,0.2 c0.4,0,0.7,0.2,1.1,0.2c0.2,0,0.7,0,0.9,0.2c0.2,0,0.7,0,0.9,0c0.4,0,0.9,0,1.1,0c0.2,0,0.4,0,0.7,0c0.7,0,1.3,0,2,0h48 c14,0,26.3-7.2,33.7-18L314,489.5C313.4,492.8,312.9,496.1,312.9,499.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M401.2,459.1h-47.8c-0.7,0-1.5,0-2.2,0c-0.2,0-0.4,0-0.7,0c-0.4,0-1.1,0-1.5,0.2c-0.2,0-0.4,0-0.7,0 c-0.7,0-1.3,0.2-2,0.2c-0.2,0-0.4,0-0.7,0.2c-0.4,0-0.9,0.2-1.5,0.2c-0.2,0-0.7,0.2-0.9,0.2c-0.4,0-0.7,0.2-1.1,0.2 c-0.2,0-0.7,0.2-0.9,0.2c-0.7,0.2-1.1,0.4-1.8,0.7c-7.7,2.8-14,7.9-18.6,14.5l18.6,5l101.6,27.4c0.7-2.8,1.1-5.9,1.1-8.8 C441.7,477.3,423.6,459.1,401.2,459.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRed);
export default __webpack_public_path__ + "static/media/icon-red.f74e17ac75210d371c023fed62a66731.svg";
export { ForwardRef as ReactComponent };